module.exports = __webpack_public_path__ + "c3d3bdf15eaa79caa7e8b7eb3f0b0d14.pdf";